// extracted by mini-css-extract-plugin
module.exports = {"cpdCertificates":"styles_cpdCertificates__3p_6b"};